import {
  IApprovalItem,
  IApprovalsDataList,
  IApprovalsFetchPayload,
  IApprovalsFetchResponse,
} from '../../shared/interfaces/approval.interface'
import { IQuery } from '../../shared/interfaces/api-query.interface'

export const APPROVAL_FETCH_APPLICATIONS = '[APPROVAL] FETCH_APPLICATIONS'
export const APPROVAL_FETCH_APPLICATIONS_SUCCESS = '[APPROVAL] FETCH_APPLICATIONS_SUCCESS'
export const APPROVAL_FETCH_APPLICATIONS_ERROR = '[APPROVAL] FETCH_APPLICATIONS_ERROR'

export const APPROVAL_FETCH_APPLICATION = '[APPROVAL] FETCH_APPLICATION'
export const APPROVAL_FETCH_APPLICATION_SUCCESS = '[APPROVAL] FETCH_APPLICATION_SUCCESS'
export const APPROVAL_FETCH_APPLICATION_ERROR = '[APPROVAL] FETCH_APPLICATION_ERROR'

export const ApprovalFetchApplications = (data: IApprovalsFetchPayload) => ({
  type: APPROVAL_FETCH_APPLICATIONS,
  payload: data,
})

export const ApprovalFetchApplicationsSuccess = (data: IApprovalsDataList) => ({
  type: APPROVAL_FETCH_APPLICATIONS_SUCCESS,
  payload: data,
})

export const ApprovalFetchApplicationsError = () => ({
  type: APPROVAL_FETCH_APPLICATIONS,
})

export const ApprovalFetchApplication = (data: IQuery) => ({
  type: APPROVAL_FETCH_APPLICATION,
  payload: data,
})

export const ApprovalFetchApplicationSuccess = (data: IApprovalItem) => ({
  type: APPROVAL_FETCH_APPLICATION_SUCCESS,
  payload: data,
})

export const ApprovalFetchApplicationError = () => ({
  type: APPROVAL_FETCH_APPLICATION_ERROR,
})
